import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  batchId: string;
  softDelete?: boolean;
}

export const useDeleteBatch = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ batchId, softDelete }: HookProps) => {
      const result = await apiClient.batchesCore.deleteBatch.mutation({ params: { id: batchId }, body: { softDelete } });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['batches'] });
      toast.success('Successfully deleted the batch!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error deleting the batch!');
    },
  });
};
